export default "__VITE_ASSET__CXd2lGvf__"